// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as OurWorkRouteImport } from './routes/our-work'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as WarrantyDiscountsRouteImport } from './routes/warranty-discounts'
import { Route as AdminSplatRouteImport } from './routes/admin.$'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const NotFoundRoute = NotFoundRouteImport.update({
            id: '/not-found',path: '/not-found',getParentRoute: () => rootRouteImport
          })
const OurWorkRoute = OurWorkRouteImport.update({
            id: '/our-work',path: '/our-work',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const WarrantyDiscountsRoute = WarrantyDiscountsRouteImport.update({
            id: '/warranty-discounts',path: '/warranty-discounts',getParentRoute: () => rootRouteImport
          })
const AdminSplatRoute = AdminSplatRouteImport.update({
            id: '/admin/$',path: '/admin/$',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,ContactRoute: ContactRoute,FaqRoute: FaqRoute,NotFoundRoute: NotFoundRoute,OurWorkRoute: OurWorkRoute,ServicesRoute: ServicesRoute,WarrantyDiscountsRoute: WarrantyDiscountsRoute,AdminSplatRoute: AdminSplatRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)